
export const queryUrlToObj = (url: string) => {
  if (url.substr(0,1) === "?") {
    url = url.slice(1, url.length)
  }
  let arr = url.split("&").map((e) => e.split("="))
  let query: any = {}
  arr.forEach((e) => {
    if (e.length !== 2) return

    let key = e[0], value = e[1];

    if (!!query[key]) {
      if (typeof query[key] === "string") {
        query[key] = [query[key], e[1]]
      } else if (!!query[key].length) {
        query[key].push(e[1])
      }
    } else {
      query[key] = e[1]
    }

  })

  return query
}
